import { useState } from "react";
import { Link } from "react-router-dom";

import { FaRegCopy } from "react-icons/fa";

import { formatPhoneString } from "../utils/StringUtils";

import Colors from "../constants/Colors";
import { Tooltip } from "reactstrap";

function CustomUserElement({ user, name, phone, alternate }) {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  if (!phone) {
    return <i>{alternate}</i>;
  }

  if (!user) {
    if (name) {
      return <text>{name}</text>;
    }
    return <i>{formatPhoneString(phone)}</i>;
  }

  const onCopy = () => {
    navigator.clipboard.writeText(user.name);
    setTooltipOpen(true);
    setTimeout(() => setTooltipOpen(false), 1000);
  };

  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <Link to={"/user-details"} state={{ phone: user.phone }}>
        {user.name}
      </Link>
      <span
        id="copy-icon"
        onClick={onCopy}
        style={{
          cursor: "pointer",
          marginLeft: "10px",
          color: Colors.quaternary,
        }}
      >
        <FaRegCopy />
      </span>
      <Tooltip isOpen={tooltipOpen} target="copy-icon" placement="top">
        {"Skopiowane!"}
      </Tooltip>
    </div>
  );
}

export default CustomUserElement;
